export const LOCKED = 1
export const UNLOCKED = 0
